import { Serializer } from 'src/app/core/common/http/serializer';
import { AreaZucchettiResource, OperationalFunctionResource, SocietyResource, TypeUserResource } from './area-zucchetti.resource';
import { AreaZucchettiModel } from '../model/area-zucchetti.model';

export class AreaZucchettiSerializer implements Serializer {
    fromJson(json: any): AreaZucchettiResource {
        const resource = new AreaZucchettiResource();

        resource.type_user = null;
        if (json.type_user) {
            resource.type_user = new TypeUserResource();
            resource.type_user.description = json.type_user;
        }


        resource.society = [];
        if (json.society && json.society.length > 0) {
            json.society[0].split(',').forEach((society: any) => {
                let societyObj = new SocietyResource();
                societyObj.value = society;
                resource.society.push(societyObj);
            });
        }

        resource.operational_function = [];
        if (json.operational_function && json.operational_function.length > 0) {
            json.operational_function[0].split(',').forEach((of: any) => {
                let ofObj = new OperationalFunctionResource();
                ofObj.value = of;
                resource.operational_function.push(ofObj);
            });

        }


        resource.notes = json.notes;
        return resource;
    }

    toJson(model: AreaZucchettiModel): any {
        const resource = new AreaZucchettiResource();
        let resp = {
            type: resource.type
        };

        resp['type_user'] = null;
        if (model.type_user && model.type_user.length > 0) {
            resp['type_user'] = model.type_user[0].description;
        }

        resp['society'] = [];
        model.society.forEach((o: any) => {
            resp['society'].push(o.value);
        });

        resp['operational_function'] = [];
        if (model.operational_function && model.operational_function.length > 0) {
            model.operational_function.forEach((o: any) => {
                resp['operational_function'].push(o.description);
            });
        }

        resp['notes'] = model.notes;

        return resp;
    }
}